<template>
  <div>
      <counter />
  </div>
</template>

<script>
import Counter from  "@/components/Counter" 
export default {
  components:{
    Counter
  }
}
</script>

<style>

</style>